import { Text, Flex, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface DataTableContainerFooterProps {
  selectedRows: number;
  text: string;
  onClear: () => void;
  totalItems?: number;
  allItemsSelected?: boolean;
  onSelectAllItems?: () => void;
}

export function DataTableContainerFooter({
  selectedRows,
  text,
  onClear,
  totalItems,
  allItemsSelected,
  onSelectAllItems,
}: DataTableContainerFooterProps) {
  const { t } = useTranslation();

  const showSelectAllOption =
    totalItems !== undefined &&
    onSelectAllItems !== undefined &&
    selectedRows > 0 &&
    !allItemsSelected &&
    selectedRows < totalItems;

  return (
    <Flex align="start" flexDir="column" pl={6}>
      <Flex align="center" gap={1}>
        <Text>
          {allItemsSelected
            ? t('searchArticles.allItemsSelected', { count: totalItems })
            : `${selectedRows}${text}`}
        </Text>
      </Flex>
      <Flex gap={2}>
        {showSelectAllOption && (
          <Button
            size="xs"
            variant="link"
            color="texas.sand.100"
            _light={{ color: 'texas.burntSienna.500' }}
            onClick={onSelectAllItems}
          >
            {t('searchArticles.selectAllItems', { count: totalItems })}
          </Button>
        )}
        <Button
          size="xs"
          variant="link"
          color="texas.sand.100"
          _light={{ color: 'texas.burntSienna.500' }}
          isDisabled={selectedRows === 0}
          onClick={onClear}
        >
          {t('general.clear')}
        </Button>
      </Flex>
    </Flex>
  );
}
